/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../config/axios";
import { useState } from "react";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { URL_API } from "../../config/default";

const Seguridad = () => {
  const [form, setForm] = useState<any>({
    password: "",
  });
  const { isPending, error, data } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/auth/me`, {
        method: "GET", // O 'POST', 'PUT', 'DELETE', etc. dependiendo de tu solicitud
        headers: {
          Authorization: myHeaders, // Un ejemplo de header de autenticación
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "Loading...";

  if (error) return "Error...";

  const submit = async (formdata: any) => {
    const requestOptions = {
      method: "PUT",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/me`, requestOptions)
      .then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);

        return Toast.fire({
          icon: "success",
          title: "Updated in successfully",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const user = data.data;

  return (
    <div className="m-auto md:w-[80%]">
      <div className="grid grid-cols-2 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">
            Inicio de sesión y seguridad
          </span>
          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Contraseña</span>
              <input
                type="password"
                id="form-password"
                className="border-0 rounded-md w-full"
                defaultValue={`${user.password}`}
                onChange={(e) => {
                  setForm({
                    ...form,
                    password: e.target.value
                  });
                }}
              />
            </div>

            <label className="font-bold">
              <div id="label-password">Actualizar</div>
              <button
                className="hidden"
                onClick={() => {
                  if (
                    document
                      .getElementById("form-password")
                      ?.classList.contains("border-0")
                  ) {
                    document
                      .getElementById("form-password")
                      ?.classList.remove("border-0");
                    document.getElementById(
                      "label-password"
                    )!.innerHTML = "Guardar";
                  } else {
                    document
                      .getElementById("form-password")
                      ?.classList.add("border-0");
                    document.getElementById(
                      "label-password"
                    )!.innerHTML = "Actualizar";

                    const formData = new FormData();
                    formData.append("_method", "PUT");
                    if (form.password !== "")
                      formData.append("password", form.password);
                    submit(formData);
                  }
                }}
              ></button>
            </label>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Seguridad;
